<div class="admin">
  <div class="container">
    <div class="row">
      <div class="col-12">
        <div class="breadcrumbs">
          <ul>
            <li>
              <a routerLink="/dashboard">
                Inicio
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div class="col-12">
        <h2 class="txt txt--title"> {{ requestType === 'driver' ? 'Buscar conductor' : 'Buscar infracción' }} </h2>
        <small> {{ requestType === 'driver' ? 'Podrás revisar la información de licencias de un conductor.' : 'Podrás revisar y gestionar el historial de infracciones de un conductor.' }} </small>
      </div>
      <div class="col-md-12 u-mt20">
        <div class="box u-mb60">
          <div class="row">
            <div class="col-lg-8">
              <app-select-list title="Buscar conductor"
                hintText="*El rut debe ser sin puntos y con guión"
                (textInputValueEmitter)="onSearchPersonTextChange($event)" [optionList]="listPersonOptions"
                placeHolder="Buscar por nombre, rut* o email" (selectedValueEmitter)="onSearchPersonSelected($event)"
                [isLoading]="loadingPersonOptions"
              >
              </app-select-list>
            </div>
            <div class="col-lg-3 offset-lg-1">
              <button type="button" class="btn btn--primary btn--big u-mt20" (click)="onSelectPerson()"
                [ngClass]="personForm.controls.id.value > 0 ? '' : 'btn--disabled'">Buscar conductor</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
